import { __read } from "tslib";
import { AdaptiveCard, HostConfig } from 'adaptivecards';
import React, { useEffect, useState } from 'react';
export var handleError = function (errorMessage, fallbackHandler) {
    fallbackHandler && fallbackHandler();
    return React.createElement(React.Fragment, null, errorMessage);
};
export var tryJsonParse = function (payload) {
    try {
        return JSON.parse(payload);
    }
    catch (error) {
        return undefined;
    }
};
export var tryRenderCard = function (card) {
    var _a;
    return (_a = card.render()) !== null && _a !== void 0 ? _a : undefined;
};
/**
 *
 * This control is intended to take in your adaptive card payload and render the adaptive card or render an error message
 *
 *
 * @param  payload JSON.stringified version of card data
 * @param  cardActionsHandler function responsible for handling card actions
 * this function should takes in an {@link Action} and perform the desired
 * @param  errorFallbackHandler function `AdaptiveCardRenderer` should call when in the case of an error
 * @param hostConfig A Host Config is a shared configuration object that allows you to define common styles
 *                   (e.g., font family, font sizes, default spacing) and behaviors (e.g., max number of actions)
 *                   that will be automatically interpreted by each platform renderer.
 * @returns  `ReactElement`
 */
export var AdaptiveCardRenderer = function (_a) {
    var payload = _a.payload, cardActionsHandler = _a.cardActionsHandler, errorFallbackHandler = _a.errorFallbackHandler, hostConfig = _a.hostConfig;
    var _b = __read(useState(React.createElement(React.Fragment, null)), 2), contentHolder = _b[0], setContentHolder = _b[1];
    var card = new AdaptiveCard();
    useEffect(function () {
        var cardObj = tryJsonParse(payload);
        if (hostConfig) {
            var hostConfigObj = tryJsonParse(hostConfig);
            if (!hostConfigObj) {
                setContentHolder(handleError('⚠ Can not parse Host Config JSON.', errorFallbackHandler));
            }
            card.hostConfig = new HostConfig(hostConfigObj);
        }
        if (!cardObj) {
            setContentHolder(handleError('⚠ Can not parse Adaptive Card JSON.', errorFallbackHandler));
        }
        else {
            card.parse(cardObj);
            card.onExecuteAction = function (action) {
                return cardActionsHandler(action);
            };
            var renderedCard_1 = tryRenderCard(card);
            if (!renderedCard_1) {
                setContentHolder(handleError('⚠ Can not render unsupported content type.', errorFallbackHandler));
            }
            else {
                setContentHolder(React.createElement("div", { 
                    /**
                     * hasChildNodes check is a fix for the stacking card issue
                     * still looking for better solution
                     */
                    ref: function (n) {
                        !(n === null || n === void 0 ? void 0 : n.hasChildNodes()) && (n === null || n === void 0 ? void 0 : n.appendChild(renderedCard_1));
                    } }));
            }
        }
        return function () {
            // cleanup;
        };
    }, [payload, cardActionsHandler]);
    return contentHolder;
};
//# sourceMappingURL=AdaptiveCardRenderer.js.map